/* eslint-disable react/jsx-props-no-spreading */
import React, { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import clsx from 'clsx';
import { useFileExplorerContext } from '../../hooks/useFileExplorerContext';
import { UploadFileModal } from './Modals/UploadFileModal';

interface FileExplorerDropzoneProps {
  children: React.ReactNode;
  className?: string;
}

export function FileExplorerDropzone({ children, className }: FileExplorerDropzoneProps) {
  const { activeFolder } = useFileExplorerContext();
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [droppedFiles, setDroppedFiles] = useState<File[]>([]);

  const onDrop = useCallback((files: File[]) => {
    if (files.length > 0) {
      setDroppedFiles(files);
      setShowUploadModal(true);
    }
  }, []);

  const handleCloseUploadModal = useCallback(() => {
    setShowUploadModal(false);
    setDroppedFiles([]);
  }, []);

  const {
    getRootProps, getInputProps, isDragActive,
  } = useDropzone({
    onDrop,
    noClick: true,
    preventDropOnDocument: true,
    disabled: !activeFolder,
  });

  return (
    <>
      <div
        className={clsx('position-relative h-100', className)}
        {...(activeFolder ? getRootProps() : {})}
      >
        {activeFolder && (
          <>
            <div
              className={clsx('dropzone border-0 position-absolute p-0 m-0 top-0 start-0 w-100 h-100 z-n1', {
                'dropzone--background': isDragActive,
                'z-2': isDragActive,
              })}
            />
            <input {...getInputProps()} />
          </>
        )}
        {children}
      </div>

      <UploadFileModal
        show={showUploadModal}
        onHide={handleCloseUploadModal}
        files={droppedFiles}
      />
    </>
  );
}
